<template>
    <div>
        <div class="row">
            <sp-card tema='' :lgGrid="6"></sp-card>
            <sp-card tema='info' :valor="10" descricao="Card Vazio" :valorProgressBar="55" tooltip="Valor arbitrario" :lgGrid="6"></sp-card>
        </div>
        <div class="row">
            <div class="flex md6 xs12">
                <sp-360-panel class="chart-widget" title="Crianças de 0-4 anos atendidas pela rede municipal de creches" :tooltipOptions="tooltipCreche">
                     <sp360-chart :data="piechartmatriculascreche" type="pie" :options="piechartmatriculascrecheOptions"/>
                </sp-360-panel>
            </div>
            <div class="flex md6 xs12">
                <sp-360-panel class="chart-widget" title="Deficit de Vagas para crianças de 0-4 anos na rede Municipal de Creches" :tooltipOptions="tooltipCreche">
                    <sp360-chart :data="piechartdeficitcreche" type="pie" :options="piechartmatriculascrecheOptions"/>
                </sp-360-panel>
            </div>
        </div>
        <div class="row">
            <div class="flex md6 xs12">
                <sp-360-panel class="chart-widget" title="Matriculas por Agrupamento de Escolas">
                    <sp360-chart :data="pieChartMatriculasPorAgrupamentoDeEscolas" :options="pieChartMatriculasPorAgrupamentoDeEscolasOptions" type="pie"/>
                </sp-360-panel>
            </div>
            <div class="flex md6 xs12">
                <sp-360-panel class="chart-widget" title="Matriculas por Modalidade">
                    <canvas id="myChart2" ref='ciclos' width="400" height="250"></canvas>
                </sp-360-panel>
            </div>
        </div>

        <div class="row">
            <sp-360-panel class="chart-widget" title="Distribuição de Matriculas por Região">
                <canvas id="myChart4" ref='barchartMatriculaRegiao' width="1400"></canvas>
            </sp-360-panel>
        </div>

        <!--
        <div class="row">
            <sp-360-panel class="chart-widget" title="Distribuição de Turmas por Região">
                <canvas id="myChart" ref='barchart' width="1400"></canvas>
            </sp-360-panel>
        </div>
        -->

        <div class="row">
            <sp-360-panel class="chart-widget" title="Distribuição de Turmas por Região">
                 <div class="flex-box">
                    <dre-map ref="mapa" id="mapaSP"/>
                    <sp360-data-table id="tabelaFilaCreche" ref="filaCreche" :apiMode="false"
                                :data="tabela.tableData.data" :fields="tabela.tableFields"
                                :perPage="tabela.itemsPerPage" />
                 </div>
            </sp-360-panel>
        </div>

    </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import DreMap from '@/components/maps/360-maps/DREMap'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

export default {
  components: {
    SpCard,
    DreMap,
    Sp360Chart, Sp360Panel, Sp360DataTable
  },
  created () {
    Promise.all([ // [0 1 2 3 4]
      this.$store.dispatch('servicosSME/buscarRedeEnsino', { agrupamento: 'NENHUM' }),
      this.$store.dispatch('servicosSME/buscarFilaCreche', { intervalo: 'MAIS_RECENTE' }),
      this.$store.dispatch('servicosSME/buscarMatriculas', { intervalo: 'MAIS_RECENTE', agrupamento: 'POR_CICLO_ENSINO' }),
      this.$store.dispatch('populacao/buscarPopulacaoPorIdadeSexo'),
      this.$store.dispatch('servicosSME/buscarRedeEnsino', { agrupamento: 'POR_DRE' }),
      this.$store.dispatch('servicosSME/buscarRedeEnsino', { agrupamento: 'POR_SUBPREFEITURA' }),
      this.$store.dispatch('servicosSME/buscarMatriculas', { intervalo: 'MAIS_RECENTE', agrupamento: 'NENHUM' }),
    ])
      .then((respostas) => {
        this.listaDemografia = _.sortBy(respostas[3].data.data, ['id'], ['desc'])
        this.cores = CorUtils.getVetorCoresPorTom('claro')
        this.calcularRede(respostas[0].data)
        this.calcularFila(respostas[1].data)
        let y = this.calcularMatriculasTurmas(respostas[0].data, respostas[2].data)
        let x = this.calcularMatricula(respostas[2].data)

        this.populatePiechartMatriculasCreche()
        this.populatePiechartDeficitCreche()
        this.populateBarchartMatriculasCreche(x)
        // this.populateBarchartTurmasPorRegiao();

        this.populateBarchartMatriculasPorRegiao(respostas[5].data)

        this.populatePiechartMatriculasporAgrupamentoDeEscolas(y)

        this.calculaCoberturaCreches(respostas[6].data)

        respostas[4].data.forEach(e => {
          for (const key in e) {
            if (e.hasOwnProperty(key)) {
              if (!e[key]) {
                e[key] = 0
              }
            }
          }
        })

        this.updateTabela(respostas[4].data)
        this.pintarRegiao(respostas[4].data)
      })
  },

  mounted () {

  },

  data () {
    return {
      piechartdeficitcreche: {},
      piechartmatriculascreche: {},
      piechartmatriculascrecheOptions: {},
      barchartTurmasPorRegiao: {},
      barchartMatriculasGeral: {},
      barchartMatriculasGeralOptions: {},
      pieChartMatriculasPorAgrupamentoDeEscolas: {},
      pieChartMatriculasPorAgrupamentoDeEscolasOptions: {},
      barChartOptions: {},
      unidadesPorSub: {},
      turmas: [],
      totalTurmasNoMunicipio: 0,
      totalMatriculas: 0,
      matriculasCreche: 0,
      matriculasCiclos: {},
      barchart: {},
      totalDemendaCreche: 0,
      listaDemografia: {},
      tooltipCreche: { content: 'De Administração Direta, indireta e Conveniada', position: 'bottom' },

      tabela: {
        titulo: 'Fila da Creche',
        tableData: {
          'data': [],
        },
        tableFields: [
          {
            name: 'nome_dre',
            sortField: 'nome_dre',
            title: 'Diretoria Regional de Ensino',
            width: '25%',
          },
          {
            name: 'total_matriculas',
            sortField: 'total_matriculas',
            title: 'Total de Matriculas',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'demanda_creche',
            sortField: 'demanda_creche',
            title: 'Demanda por Creche',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'total_matriculas_creche',
            sortField: 'total_matriculas_creche',
            title: 'Matriculas em Creches',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          }, {
            name: 'total_matriculas_pre',
            sortField: 'total_matriculas_pre',
            title: 'Matriculas em Pré-Escola',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'total_matriculas_ciclo_1',
            sortField: 'total_matriculas_ciclo_1',
            title: 'Matriculas Ciclo Fundamental I',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'total_matriculas_ciclo_2',
            sortField: 'total_matriculas_ciclo_2',
            title: 'Matriculas Ciclo Fundamental II',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'total_matriculas_ciclo_3',
            sortField: 'total_matriculas_ciclo_3',
            title: 'Matriculas Ciclo Fundamental III',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'total_matriculas_sem_ciclo',
            sortField: 'total_matriculas_sem_ciclo',
            title: 'Matriculas Sem Ciclo',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'total_matriculas_modular',
            sortField: 'total_matriculas_ciclo_3',
            title: 'Matriculas Profissionalizante',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
        ],

        sortFunctions: {
          'nome_subprefeitura': MethGlob.ordenaTabela,
          'nome_dre': MethGlob.ordenaTabela,
          'demanda_creche': MethGlob.ordenaTabelaParseInt,
          'total_matriculas': MethGlob.ordenaTabelaParseInt,
          'total_matriculas_ciclo_1': MethGlob.ordenaTabelaParseInt,
          'total_matriculas_ciclo_2': MethGlob.ordenaTabelaParseInt,
          'total_matriculas_ciclo_3': MethGlob.ordenaTabelaParseInt,
          'total_matriculas_creche': MethGlob.ordenaTabelaParseInt,
          'total_matriculas_modular': MethGlob.ordenaTabelaParseInt,
          'total_matriculas_sem_ciclo': MethGlob.ordenaTabelaParseInt,
          'total_matriculas_pre': MethGlob.ordenaTabelaParseInt,
        },

        topTooltipOptions: {
          content: this.$t('graficosEducacao.filaDaCrecheNotaTecnica') + '</br>' + this.$t(
            'graficosEducacao.filaDaCrecheNotaTecnica2'),
          placement: 'bottom',
          classes: 'va-tooltip customTooltip',
        },

        itemsPerPage: 13,
      },
    }
  },

  methods: {
    updateTabela (dados) {
      this.$set(this.tabela.tableData, 'data', _.orderBy(dados, 'total_matriculas', 'desc'))
      // this.$refs.filaCreche.update()
    },

    pintarRegiao (dados) {
      dados = _.sortBy(dados, 'total_matriculas')

      let matriculas_municipio = _.reduce(dados, function (sum, n) {
        return sum + n.total_matriculas
      }, 0)
      let legendaCores = (CorUtils.getVetorCoresPorTom('claro'))

      this.$refs.mapa.definirLegenda(legendaCores, ['Distribuição de Matriculas', 'Q1', 'Q2', 'Q3', 'Q4'])

      dados.forEach(element => {
        let x = (element.total_matriculas)
        let mediaSub = ((matriculas_municipio / dados.length))

        let id = 'DRE-' + element.id_dre
        let rgb = ''

        if (x >= mediaSub * 1.5) {
          rgb = legendaCores[3]
        } else if (x >= mediaSub * 1) {
          rgb = legendaCores[2]
        } else if (x >= mediaSub * 0.5) {
          rgb = legendaCores[1]
        } else {
          rgb = legendaCores[0]
        }

        this.$refs.mapa.pintarRegiao(id, rgb)
      })
    },

    consolidarCreches (filaCreche, redeEnsino) {
    },

    calcularRede (dados) {
      let arSubs = []
      this.unidadesPorSub = _.groupBy(dados, 'nome_subprefeitura')
      this.turmas = []
      this.totalTurmasNoMunicipio = 0

      let crecheDireta = 0
      let crecheIndireta = 0
      let crecheConveniada = 0
      for (const key in this.unidadesPorSub) {
        let sub = ''
        let total = 0
        let creches = 0

        let escolas = 0
        if (this.unidadesPorSub.hasOwnProperty(key)) {
          sub = key
          this.unidadesPorSub[key].forEach(e => {
            switch (e.tipo) {
              case 'CECI':
              case 'CEMEI':
              case 'CEU CEI':
              case 'CCI/CIPS':
              case 'CEI DIRET':
                crecheDireta += 1
                break
              case 'CEI INDIR':
                crecheIndireta += 1
                break
              case 'CR.P.CONV':
              case 'ESC.PART.':
                crecheConveniada += 1
                break
              default:
                escolas += 1
                break
            }
            total += e.numero_turmas
            this.totalTurmasNoMunicipio += e.numero_turmas
          })
          this.turmas.push({ sub: sub, total: total, creches: creches, escolas: escolas })
        }
      }
      this.unidadesCreche = [crecheDireta, crecheIndireta, crecheConveniada]

      this.turmas = _.orderBy(this.turmas, 'total', 'desc')
    },

    calcularFila (dados) {
      dados.forEach(e => {
        e.minigrupo = e.mini_grupo_i + e.mini_grupo_ii
        e.bercario = e.bercario_ii + e.bercario_i
        this.totalDemendaCreche += e.minigrupo + e.bercario
      })
    },

    calcularMatricula (dados) {
      let x = []
      let ciclos = _.groupBy(dados, 'ciclo_ensino')

      for (const key in ciclos) {
        if (ciclos.hasOwnProperty(key)) {
          _.reduce(ciclos[key], function (result, value) { return result += value.matriculas }, 0)
          x.push({ ciclo: key, matriculas: _.reduce(ciclos[key], function (result, value) { return result += value.matriculas }, 0) })
        }
      }
      dados.forEach(e => {
        if (e.ciclo_ensino == 'CRECHE') {
          this.matriculasCreche += e.matriculas
        }
        this.totalMatriculas += e.matriculas
      })
      x = _.orderBy(x, [(o) => { return (o.matriculas) }], 'desc')
      this.matriculasCiclos = ciclos
      return x
    },

    calculaCoberturaCreches (dados) {
      let direta = 0
      let indireta = 0
      let conveniada = 0
      let total = 0
      let label = ['diretas', 'indiretas', 'parceiras']
      let data = []
      dados.forEach(d => {
        if (d.ciclo_ensino === 'CRECHE') {
          switch (d.tipo_escola) {
            case 'CECI':
            case 'CEMEI':
            case 'CEU CEI':
            case 'CCI/CIPS':
            case 'CEI DIRET':
              direta += d.matriculas

              break
            case 'CEI INDIR':
              indireta += d.matriculas
              break
            case 'CR.P.CONV':
            case 'ESC.PART.':
              conveniada += d.matriculas
              break
          }
        }
      })
      total = direta + indireta + conveniada
      let dataset = [direta, indireta, conveniada]

      return { labels: label, datasets: [dataset] }
    },

    populatePiechartCoberturaCreche (dados) {
      this.piechartCoberturaCrecheOptions = {
        legend: {
          position: 'left',
          align: 'center',
          labels: {
            usePointStyle: 'true',
          },
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(true, false, 'pie'),
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => value ? value + '%' : null,
            clamp: true,
            anchor: 'center',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
      }

      this.piechartCoberturaCreche = calculaCoberturaCreches(dados)
    },

    calcularMatriculasTurmas (rede, matriculas) {
      // calcula dados
      let x = _.groupBy(rede, 'tipo')
      let y = _.groupBy(matriculas, 'tipo_escola')
      let datasets = []
      let ceu = { nome: 'CEU´s', turmas: 0, matriculas: 0 }
      for (const key in x) {
        if (x.hasOwnProperty(key)) {
          const e = x[key]
          const l = y[key]
          if (key.includes('CEU')) {
            ceu.turmas += _.reduce(e, (sum, e) => sum + e.numero_turmas, 0)
            ceu.matriculas += _.reduce(l, (sum, l) => sum + l.matriculas, 0)
          } else {
            datasets.push({
              nome: key,
              turmas: _.reduce(e, (sum, e) => sum + e.numero_turmas, 0),
              matriculas: _.reduce(l, (sum, l) => sum + l.matriculas, 0),
            })
          }
        }
      }
      datasets.push(ceu)
      return _.orderBy(datasets, 'matriculas', 'desc')
    },

    populatePiechartMatriculasCreche () {
      this.piechartmatriculascrecheOptions = {
        legend: {
          position: 'left',
          align: 'center',
          labels: {
            usePointStyle: 'true',
          },
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(true, false, 'pie'),
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => value ? value + '%' : null,
            clamp: true,
            anchor: 'center',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
      }

      let criancas = this.listaDemografia[0].dados[0]
      criancas.total = criancas.feminino + criancas.masculino

      this.piechartmatriculascreche = {}
      this.piechartmatriculascreche.labels = [
        'Crianças fora da rede municipal de creches',
        'Crianças matriculadas na rede municipal de creches',
        'Crianças na fila da creche']
      this.piechartmatriculascreche.datasets = []

      let a = (this.matriculasCreche + this.totalDemendaCreche)
      let b = (this.totalMatriculas + this.totalDemendaCreche)

      let dataset = {
        backgroundColor: this.cores,
        data: [this.percentage(criancas.total - a, criancas.total),
          this.percentage(this.matriculasCreche, criancas.total),
          this.percentage(this.totalDemendaCreche, criancas.total),
          0,
          0,
        ],
      }
      this.piechartmatriculascreche.datasets.push(dataset)
    },

    populatePiechartDeficitCreche () {
      let cores = this.cores.slice(1)
      this.piechartmatriculascrecheOptions = {
        legend: {
          position: 'left',
          labels: {
            usePointStyle: 'true',
          },
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(true, false, 'pie'),
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => value ? value + '%' : null,
            clamp: true,
            anchor: 'center',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
      }

      this.piechartdeficitcreche = {}
      this.piechartdeficitcreche.labels = [
        'Matriculas em creches',
        'Défict da vagas de creche']
      this.piechartdeficitcreche.datasets = []

      let a = (this.matriculasCreche + this.totalDemendaCreche)
      let b = (this.totalMatriculas + this.totalDemendaCreche)

      let dataset = {
        backgroundColor: cores,
        data: [
          this.percentage(this.matriculasCreche, a),
          this.percentage(this.totalDemendaCreche, a) * -1,
        ],
      }
      this.piechartdeficitcreche.datasets.push(dataset)
    },

    populateBarchartMatriculasCreche (matriculasCiclos) {
      let palette = this.$store.getters.palette
      let datasets = []
      let options = {
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return MethGlob.thousandSeparator(value)
              },
            },
          }],
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'bar'),
        },
      }
      let dataset = {
        backgroundColor: [],
        borderColor: palette.transparent,
        data: [] }

      let labels = []
      matriculasCiclos.forEach(e => {
        labels.push(e.ciclo)
        dataset.backgroundColor.push(this.getMeAColor()),
        dataset.data.push(e.matriculas)
      })

      datasets.push(dataset)
      this.barchart = new Chart(this.$refs.ciclos, { type: 'bar', data: { labels: labels, datasets: datasets }, options: options })
    },

    populateBarchartTurmasPorRegiao () {
      let barChartOptions = {
        responsive: true,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = (value * 100 / sum).toFixed(2) + '%' + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
              return percentage
            },
            anchor: 'end',
            align: 'center',
            color: '#000',
            display: 'true',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: 'true',
          },
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'bar'),
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
            },
          }],
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return MethGlob.thousandSeparator(value)
              },
            },
          }],
        },
      }

      this.barchartTurmasPorRegiao.labels = []
      this.barchartTurmasPorRegiao.datasets = []

      let datasetTotal = this.getDataSetObject('Total de Turmas')
      let datasetEscolas = this.getDataSetObject('Pre-Escola, Fundamental, Medio e Profissionalizante')
      let datasetCreche = this.getDataSetObject('Creches')

      this.turmas.forEach(e => {
        this.barchartTurmasPorRegiao.labels.push(e.sub)
        datasetTotal.data.push(e.total)
        datasetEscolas.data.push(e.escolas)
        datasetCreche.data.push(e.creches)
      })

      // this.barchartTurmasPorRegiao.datasets.push(datasetTotal);
      this.barchartTurmasPorRegiao.datasets.push(datasetCreche)
      this.barchartTurmasPorRegiao.datasets.push(datasetEscolas)

      this.chart = new Chart(this.$refs.barchart, {
        type: 'bar',
        data: this.barchartTurmasPorRegiao,
        options: barChartOptions,
      })
    },

    populateBarchartMatriculasPorRegiao (dados) {
      let barChartMatriculasRegiaoOptions = {
        responsive: true,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = (value * 100 / sum).toFixed(2) + '%' + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
              return percentage
            },
            anchor: 'end',
            align: 'center',
            color: '#000',
            display: 'true',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: 'true',
          },
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'bar'),
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
            },
          }],
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return MethGlob.thousandSeparator(value)
              },
            },
          }],
        },
      }

      let barchartMatriculasPorRegiao = {
        labels: [],
        datasets: [],
      }

      let datasetTotal = this.getDataSetObject('Total de Matriculas')
      let datasetEscolas = this.getDataSetObject('Pre-Escola, Fundamental, Medio e Profissionalizante')
      let datasetCreche = this.getDataSetObject('Creches')

      dados = _.orderBy(dados, ['total_matriculas'], ['desc'])

      dados.forEach(e => {
        barchartMatriculasPorRegiao.labels.push(e.nome_subprefeitura)
        datasetTotal.data.push(e.total_matriculas)
        datasetEscolas.data.push(e.total_matriculas - e.total_matriculas_creche)
        datasetCreche.data.push(e.total_matriculas_creche)
      })

      // barchartMatriculasPorRegiao.datasets.push(datasetTotal);
      barchartMatriculasPorRegiao.datasets.push(datasetCreche)
      barchartMatriculasPorRegiao.datasets.push(datasetEscolas)

      this.chartMatriculasPorRegiao = new Chart(this.$refs.barchartMatriculaRegiao, {
        type: 'bar',
        data: barchartMatriculasPorRegiao,
        options: barChartMatriculasRegiaoOptions,
      })
    },

    percentage (partialValue, totalValue) {
      return ((100 * partialValue) / totalValue).toFixed(2)
    },

    getMeAColor () {
      return _.shuffle(this.cores).shift()
    },

    getDataSetObject (label, borderColor, backgroundColor, data) {
      let palette = this.$store.getters.palette
      return {
        backgroundColor: borderColor || this.getMeAColor(),
        borderColor: borderColor || palette.transparent,
        data: [],
        label: label || 'Sem Rótulo',
      }
    },

    setDataSetLabel (e) {
      let ciclo = e.ciclo.toLowerCase()
      if (ciclo === 'creche' || ciclo === 'pre') {
        return 'Educação Infantil'
      } else if (ciclo === 'ciclo i' || ciclo === 'ciclo ii' || ciclo === 'ciclo iii') {
        return 'Ensino Fundamental'
      } else if (ciclo === 'sem ciclo' || ciclo === 'modular') {
        return 'Ensino Médio / Profissionalizante'
      }
    },

    populatePiechartMatriculasporAgrupamentoDeEscolas (dados) {
      let dataset = {
        backgroundColor: _.shuffle(this.cores),
        data: [],
      }
      let labels = []
      dados.forEach(d => {
        labels.push(d.nome)
        dataset.data.push(d.matriculas)
      })

      this.pieChartMatriculasPorAgrupamentoDeEscolasOptions = {
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'pie'),
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 35,
            bottom: 35,
          },
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = (value * 100 / sum).toFixed(2) + '%' + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
              return percentage
            },
            anchor: 'end',
            align: 'end',
            color: '#000',
            display: 'auto',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
        legend: {
          position: 'left',
          labels: {
            usePointStyle: 'true',
          },
        },
      }

      this.pieChartMatriculasPorAgrupamentoDeEscolas = {
        labels: labels,
        datasets: [dataset],
      }
    },

    matriculasporTurma (rede, matriculas) {

    },

  },
}
</script>

<style lang="scss" scoped>
    .flex-box {
        display: flex;
    }

    #mapaSP {
        width: 25%;
    }

    #tabelaFilaCreche {
        width: 75%;
        height: auto
    }

</style>

<style lang="scss">
    .customTooltip {
        .tooltip-inner {
            border-radius: 16px;
            padding: 5px 10px 4px;
            text-align: left;
        }
    }
</style>
